// extracted by mini-css-extract-plugin
export default {"container_page":"romantic-life_container_page__Kf8yp","text":"romantic-life_text__cO+mC","couple_image":"romantic-life_couple_image__pdE90"};